import {css} from "styled-components";

/**
 * The caret a native select gets back once `appearance: none` has dropped the platform's own, drawn as a CSS
 * mark on the select's positioned wrapper instead of an image on the select, so its colour is a token and
 * follows light and dark rather than a hex baked into a data URI. One definition for every such select (the
 * delete-account reason, the pricing comparison's plan pickers).
 *
 * A wrapper sets what differs through custom properties: `--select-caret-inset` (from its right edge, 16px),
 * `--select-caret-size` (8px), `--select-caret-stroke` (1.8px) and `--select-caret-color` (the tertiary ink).
 */
export const selectCaret = css`
	position: relative;

	&::after {
		content: "";
		position: absolute;
		top: 50%;
		right: var(--select-caret-inset, 16px);
		width: var(--select-caret-size, 8px);
		height: var(--select-caret-size, 8px);
		border-right: var(--select-caret-stroke, 1.8px) solid var(--select-caret-color, ${({theme}) => theme.tokens.ink3});
		border-bottom: var(--select-caret-stroke, 1.8px) solid var(--select-caret-color, ${({theme}) => theme.tokens.ink3});
		transform: translateY(-70%) rotate(45deg);
		pointer-events: none;
	}
`;
